<template>
    <div>
        <Card dis-hover :bordered="false">
            <Row>
                <Col span="10">
                    <h3 v-if="!readonly">{{$t('route.fpzLiabilityAdd')}}</h3>
                    <h3 v-else>{{$t('route.fpzliabilityDetail')}}</h3>
                </Col>
                <Col span="14">
                    <Steps :current="step">
                        <Step :title="$t('fpzInvaccCommon.t1')"></Step>
                        <Step :title="$t('fpzInvaccCommon.t2')"></Step>
                        <Step :title="$t('fpzInvaccCommon.t3')"></Step>
                    </Steps>
                </Col>
            </Row>
        </Card>
        <Card >
            <Form ref="formHeader" :model="invaccHeader" :label-width="90" :rules="ruleValidate">
                <Row>
                    <Col span="6" push="2">
                        <FormItem :label="$t('fpzLiabilityCommon.t1')" prop="orgId">
                            <Select v-model="invaccHeader.orgId" :disabled="readonly" @on-change="ouOnChange">
                                <Option v-for="item in ouList" :value="item.value" :key="item.value">{{ item.label
                                }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4" push="2">
                        <FormItem :label="$t('fpzLiabilityCommon.t2')" prop="endDate">
                            <Input v-model="invaccHeader.endDate" readonly></Input>
                        </FormItem>
                    </Col>
                    <Col span="4" push="2">
                        <FormItem :label="$t('fpzLiabilityCommon.t3')" prop="status">
                            <Select v-model="invaccHeader.status" disabled>
                                <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label
                                }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="4" push="2" v-if="readonly">
                        <FormItem :label="$t('fpzLiabilitySearch.t13')" prop="sumQuantity">
                            <Input v-model="invaccHeader.sumQuantity" readonly></Input>
                        </FormItem>
                    </Col>
                </Row>

                <Row type="flex" justify="center">
                    <Col>
                        <Button v-if="!readonly" type="primary" class="mr8" @click="search" :loading="loading">
                            {{$t('fpzInvaccCommon.t11')}}
                          </Button>
                          <Button v-if="!readonly" type="ghost" class="mr8" @click="cleanData">
                            {{$t('fpzInvaccCommon.t12')}}
                          </Button>
                          <Button v-if="!readonly" type="primary" class="mr8" @click="save" :loading="loading">
                            {{$t('fpzInvaccCommon.t13')}}
                          </Button>
                          <Button type="primary" class="mr8" @click="goBack">{{$t('fpzInvaccCommon.t14')}}</Button>
                    </Col>
                </Row>
            </Form>
        </Card>
        <Tabs :value="invaccDetailTabs">
            <TabPane :label="$t('fpzInvaccCommon.t16')" name="TrcItemDetail">
                <Card class="fpzInvacc-layout">
                    <p slot="title">
                        <Icon type="ios-film-outline"></Icon>
                        {{$t('fpzInvaccCommon.t23')}}
                    </p>
                    <m-assembly-table ref='pageForm'
                        :columns='detailModule.columns'
                        :data='detailModule.tableData'
                        :tableButtons='detailModule.tableButtons'
                        :loading='loading'
                        :currentPage='detailModule.settings.currentPage'
                        :pageSize='detailModule.settings.pageSize'
                        :total='detailModule.settings.total'
                        :settings='detailModule.settings'
                        @onPageSizeChange='detailOnPageSizeChange'
                        @onCurrentPageChange='detailOnPageChange'
                    >
                    </m-assembly-table>
                  </Card>
            </TabPane>

            <TabPane :label="$t('fpzInvaccCommon.t15')" name="invaccItemDetail" v-if="readonly">
                <!-- <Card class="fpzInvacc-layout" v-if="!readonly">
                    <p slot="title">
                        <Icon type="ios-film-outline"></Icon>
                        {{$t('fpzInvaccCommon.t23')}}
                    </p>
                    <m-assembly-table ref='pageForm'
                        :columns='detailModule.columns'
                        :data='detailModule.tableData'
                        :tableButtons='detailModule.tableButtons'
                        :loading='loading'
                        :currentPage='detailModule.settings.currentPage'
                        :pageSize='detailModule.settings.pageSize'
                        :total='detailModule.settings.total'
                        :settings='detailModule.settings'
                        @onPageSizeChange='detailOnPageSizeChange'
                        @onCurrentPageChange='detailOnPageChange'
                    >
                    </m-assembly-table>
                </Card> -->

                <Card class="fpzInvacc-layout">
                    <p slot="title">
                        <Icon type="ios-film-outline"></Icon>
                        {{$t('fpzInvaccCommon.t17')}}
                    </p>
                    <m-assembly-table ref='pageForm'
                        :columns='summaryModule.columns'
                        :data='summaryModule.tableData'
                        :tableButtons='summaryModule.tableButtons'
                        :loading='loading'
                        :currentPage='summaryModule.settings.currentPage'
                        :pageSize='summaryModule.settings.pageSize'
                        :total='summaryModule.settings.total'
                        :settings='summaryModule.settings'
                        @onPageSizeChange='summaryOnPageSizeChange'
                        @onCurrentPageChange='summaryOnPageChange'
                    >
                    </m-assembly-table>
                  </Card>
            
            </TabPane>
        </Tabs>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
// import moment from 'moment';
import axios from 'axios';
import {getOuList, queryList, dateTimeChange, exportExcel} from './financialAccounting';
export default {
    components: {
        mAssemblyTable,
    },
    props: {
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            step: 0,
            invaccHeader: {
                headerId: '',
                orgId: '',
                status: '',
                sumQuantity: '',
                endDate: ''
            },
            ruleValidate: {
                orgId: [{required: true, message: this.$t('fpzInvaccCommon.t5')}],
            },
            ouList: [],
            statusList: [],
            loading: false,
            invaccDetailTabs: 'TrcItemDetail',
            summaryModule: {
                columns: {
                    columns: [
                        {
                            title: this.$t('fpzInvaccCommon.t19'), // 物料编码
                            align: 'center',
                            key: 'itemCode',
                            minWidth: 180
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t20'), // 物料描述
                            key: 'itemDescription',
                            tooltip: true,
                            minWidth: 300
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t21'), // 单位
                            align: 'center',
                            key: 'uom',
                            minWidth: 120
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t22'), // 接收/退货数量
                            align: 'center',
                            key: 'tranUninvoicedQuantity',
                            minWidth: 120
                        }
                    ]
                },
                tableData: [],
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('fpzInvaccCommon.t32'),
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                exportExcel(button, this, this.invaccHeader, '/gscint/hw/liability/exportyLineSummary');
                            }
                        }
                    ]
                },
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            detailModule: {
                columns: {
                    columns: [
                        {
                            title: this.$t('fpzInvaccCommon.t19'), // 物料编码
                            align: 'center',
                            key: 'itemCode',
                            minWidth: 110
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t20'), // 物料描述
                            key: 'itemDescription',
                            tooltip: true,
                            minWidth: 200
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t29'), // 接收单号
                            align: 'center',
                            key: 'receiptNumber',
                            minWidth: 120
                        },
                        {
                            title: this.$t('fpzLiabilityCommon.t5'), // 接收日期
                            align: 'center',
                            key: 'transactionDate',
                            minWidth: 130,
                            render: (h, params) => {
                                let {transactionDate, organizationCode} = params.row;
                                return h('span', dateTimeChange(transactionDate, organizationCode, this));
                            }
                        },
                        {
                            title: this.$t('fpzLiabilityCommon.t6'), // PO单号
                            align: 'center',
                            key: 'poNumber',
                            minWidth: 150
                        },
                        {
                            title: this.$t('fpzLiabilityCommon.t7'), // 事务处理未开票数量
                            align: 'center',
                            key: 'tranUninvoicedQuantity',
                            minWidth: 100
                        },
                        {
                            title: this.$t('fpzLiabilityCommon.t8'), // 是否GSC发票
                            align: 'center',
                            key: 'gscInvoiceFlag',
                            minWidth: 80
                        },
                        {
                            title: this.$t('gscInvoice.t91'), // GSC发票号
                            align: 'center',
                            key: 'ispInvoiceCode',
                            minWidth: 110
                        }
                    ]
                },
                tableData: [],
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('fpzInvaccCommon.t32'),
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                this.$refs.formHeader.validate((valid) => {
                                    if (valid) {
                                        exportExcel(button, this, this.invaccHeader, this.readonly ? '/gscint/hw/liability/exportyLines' : '/gscint/hw/liability/exportIapReceips');
                                    }
                                });
                            }
                        }
                    ]
                },
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            }
        }
    },
    methods: {
        async summarySearch () {
            let {currentPage, pageSize} = this.summaryModule.settings;
            let {endDate, headerId, orgId} = this.invaccHeader;
            this.loading = true;
            await queryList(`/gscint/hw/liability/${this.readonly ? 'queryLineSummary' : 'queryIapReceipSummary'}`, {
                vendorCode: this.vendorCode,
                endDate,
                headerId,
                orgId,
                pageNum: currentPage,
                pageSize
            }, this)
            .then(({list, total}) => {
                this.summaryModule.tableData = list;
                this.summaryModule.settings.total = total;
            });
            this.loading = false;
        },
        summaryOnPageSizeChange (pageNum, pageSize) {
            let obj = this.summaryModule.settings;
            obj.currentPage = 1;
            obj.pageSize = pageSize;
            this.summarySearch();
        },
        summaryOnPageChange (pageNum, pageSize) {
            let obj = this.summaryModule.settings;
            obj.currentPage = pageNum;
            this.summarySearch();
        },
        async detailSearch () {
            let {currentPage, pageSize} = this.detailModule.settings;
            let {endDate, headerId, orgId} = this.invaccHeader;
            this.loading = true;
            await queryList(`/gscint/hw/liability/${this.readonly ? 'queryLines' : 'queryIapReceips'}`, {
                vendorCode: this.vendorCode,
                endDate,
                headerId,
                orgId,
                pageNum: currentPage,
                pageSize
            }, this)
            .then(({list, total}) => {
                this.detailModule.tableData = list;
                this.detailModule.settings.total = total;
            });
            this.loading = false;
        },
        detailOnPageSizeChange (pageNum, pageSize) {
            let obj = this.detailModule.settings;
            obj.currentPage = 1;
            obj.pageSize = pageSize;
            this.detailSearch();
        },
        detailOnPageChange (pageNum, pageSize) {
            let obj = this.detailModule.settings;
            obj.currentPage = pageNum;
            this.detailSearch();
        },
        ouOnChange (val) {
            if (val && !this.readonly) {
                this.getEndDate(val);
                this.syncData();
            }
        },
        fromValidate () {
            let flag = false;
            this.$refs.formHeader.validate((valid) => {
                flag = valid;
            });
            return flag;
        },
        search () {
            if (this.fromValidate()) {
                this.detailModule.settings.current = 1;
                this.detailSearch();
            }
        },
        save () {
            if (this.fromValidate()) {
                this.loading = true;
                axios.post('/gscint/hw/liability/save', {
                    vendorCode: this.vendorCode,
                    ...this.invaccHeader
                })
                .then((res) => {
                    this.loading = false;
                    let {success, msg, data} = res.data;
                    if (success && data && data.code !== -1) {
                        this.$Modal.success({
                            content: this.$t('fpzInvaccCommon.t39')
                        });
                        this.$closeTab({
                            name: 'fpzLiabilityAdd'
                        });
                    } else {
                        this.$Modal.error({
                            content: msg || (data && data.message)
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
            }
        },
        goBack () {
            this.$router.push({
                name: 'fpzLiabilitySearch'
            });
        },
        getEndDate (orgId) {
            axios.post('/gscint/hw/liability/getEndDate', {
                orgId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                let data = res.data.data.data;
                if (data) {
                    this.invaccHeader.endDate = data;
                }
            })
        },
        /* 查询头信息 */
        queryHeader (headerId) {
            this.loading = true;
            axios.post('/gscint/hw/liability/queryHeader', {
                headerId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data) {
                    this.invaccHeader = {
                        ...data,
                        orgId: String(data.orgId)
                    }
                    let stepObj = {
                        'NEW': 1,
                        'REJECT': 3,
                        'VCONFIRM': 2,
                        'CLOSED': 3
                    }
                    this.step = stepObj[this.invaccHeader.status];
                    this.$nextTick(() => {
                        this.summaryModule.settings.currentPage = 1;
                        this.detailModule.settings.currentPage = 1;
                        this.detailSearch();
                        this.summarySearch();
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* 同步数据 */
        syncData () {
            this.loading = true;
            axios.post('/gscint/hw/liability/syncData', {
                vendorCode: this.vendorCode,
                orgId: this.invaccHeader.orgId
            })
            .then(() => {
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            });
        },
        cleanData () {
            this.$refs['formHeader'].resetFields();
            this.invaccHeader.status = 'NEW';
            this.detailModule.tableData = [];
            this.detailModule.settings.total = 0;
            this.detailModule.settings.currentPage = 1;
        },
        init () {
            getOuList((data) => {
                this.ouList = data;
            });
            this.getDict('INT_RECONCILIATION_STATUS', (data) => {
                this.statusList = data;
            });
            if (this.readonly) {
                this.invaccHeader.headerId = this.$route.query.headerId;
                this.queryHeader(this.invaccHeader.headerId);
            } else {
                this.invaccHeader.status = 'NEW';
            }
        }
    },
    mounted() {
        this.init();
    },
    activated() {
        this.init();
    },
}
</script>
<style lang="less" scoped>
.mr8 {
    margin-right: 8px;
}
</style>